import React from 'react'
import { Routes, Route } from "react-router-dom";
import Home from '../../Pages/Home';
import Manual from '../../Pages/Manual';
import Language from '../../Pages/Language';
import TransactionHistory from '../../Pages/TransactionHistory';
import Status from '../../Pages/Status';


const Routing = (props) => {

    return (
        <Routes>
            <Route path="/" element={<Home />}></Route>
            {/* <Route path="Manual" element={<Manual />}></Route> */}
            {/* <Route path="Language" element={<Language />}></Route> */}
            <Route path="TransactionHistory" element={<TransactionHistory />}></Route>
            <Route path="Status" element={<Status />}></Route>

        </Routes>
    )
}


export default Routing